<template>
  <div class="card">
    <h5 class="card-header text-truncate w-100">
      Artículos sin existencia
    </h5>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table mb-0 table-nowrap align-middle" id="articulos-sin-existencia" style="min-height: 250px;">
          <thead>
            <tr>
              <th style="width:50px"></th>
              <th>Nombre del artículo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(articulo,index) in articulos" :key="`articulo-sin-existencia-${index+1}`">
              <td>
                <div style="min-height: 30px; display: inline-block">
                  <a
                    href="#"
                    onclick="return false;"
                    @click="mostarGaleriaFotosArticulo(articulo.id)"
                    v-if="articulo.foto_principal"
                  >
                    <img
                      :src="`${API}/articulos/${articulo.id}/fotos/principal?tipo_foto=64x64&_tk=${tk}`"
                      style="width:30px; height:30px;"
                      class="rounded-circle"
                    />
                  </a>
                  <img
                    :src="inventarioIcon"
                    v-if="!articulo.foto_principal"
                    style="width:30px; height:30px;"
                    class="rounded-circle"
                  />
                </div>
              </td>
              <td style="font-size: 15px;">
                {{articulo.nombre}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <div class="row">
        <div class="col-12 text-right">
          <router-link
            class="btn btn-outline-secondary btn-sm text-truncate"
            :to="{
              name: 'listadoArticulos',
              query: {
                tipo_existencia: 3
              }
            }"
          >
            <i class="mdi mdi-eye"></i>
            Mostrar lista completa
          </router-link>
        </div>
      </div>
    </div>
    <cmp-galeria-fotos 
      ref="galeria_sin_existencias_articulo"
      :nombreGaleria="`galeria-sin-existencias-articulo`"
    />
  </div>
</template>

<script>
import ArticuloSrv from '@/services/inventario/ArticuloSrv.js'
import inventarioIcon from '@/assets/img/inventario/inventario.png'
import CmpGaleriaFotos from "../CmpGaleriaFotos.vue"
import {APIINV as API} from '@/API.js'

export default {
  name: 'WArticulosSinExistencias',
  components: {
    CmpGaleriaFotos
  },
  data() {
    return {
      API: API,
      tk: localStorage.getItem('argusblack.token'),
      inventarioIcon: inventarioIcon,
      articulos: []
    }
  },
  created() {
    var self = this

    self.refrescarArticulos()
  },
  methods: {
    mostarGaleriaFotosArticulo: function(idArticulo) {
      var self = this
      self.$refs.galeria_sin_existencias_articulo.mostrarGaleria(idArticulo)
    },
    refrescarArticulos: function() {
      var self = this

      iu.spinner.mostrar('#articulos-sin-existencia')

      let params = {
        sin_paginacion: true,
        sin_existencia: true,
        limite:10
      }

      ArticuloSrv.articulosJSON(params).then(response => {
        let page = response.data
        self.articulos = page
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar las familias de articulos'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally (() => {
        iu.spinner.ocultar('#articulos-sin-existencia')
      })
    }
  },
  mounted: function() {
    iu.spinner.mostrar('#articulos-sin-existencia')
  }
}
</script>

<style scoped>
.text-truncate {
  width: 30%;
}
</style>